<template>
  <header class="masthead" :style="getBackdrop()">
    
    <div class="container">
      <div class="masthead-subheading">
        <img class="img-fluid" src="../assets/logo.png" />
      </div>
      <!-- <div class="masthead-heading text-uppercase">Black Monday Radio</div> -->

      <div class="container">
        <div class="row">
          <div class="col-sm"></div>
          <div class="col-sm">
            <div v-if="isLive" class="live list-group">
              <a
                href
                title="Click here to start listening thru Shoutcast."
                class="live btn btn-lg btn-dark text-uppercase mb-2"
                @click.prevent="listenThruLivePlayer"
              >
                <i class="fas fa-circle"></i>&nbsp; Listen Live
              </a>

              <a
                title="Click here to start listening, start chatting thru Twitch."
                class="live btn btn-lg btn-dark text-uppercase"
                target="_blank"
                href="https://www.twitch.tv/blackmondayradio"
              >
                <i class="fas fa-circle"></i>&nbsp; Live @ Twitch
              </a>
            </div>
          </div>
          <div class="col-sm"></div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import _ from "lodash";
var date = null;
var player = null;
var playerStatus = null;
var backdrops = null;
var backdropImages = [];

export default {
  name: "mastHead",
  data: function () {
    return {
      headerImageStyle: "",
      isLive: false,
    };
  },
  created: function () {
    var self = this;
    var liveHour = -1;

    date = new Date();

    setInterval(function () {
      // monday
      liveHour = _.indexOf([17, 18, 19, 20, 21, 22, 23], date.getHours());

      if (date.getDay() === 1 && liveHour !== -1) {
        self.isLive = true;
      } else {
        self.isLive = false;
      }
    }, 60000);

    // backdrop
    self.headerImageStyle = self.getBackdrop();
  },
  computed: {},
  watch: {
    $route() {
      this.headerImageStyle = this.getBackdrop();

      let element = document.getElementById("portfolio");
      if (!element) {
        element = document.getElementById("contact");
      }
      element.scrollIntoView({
        behavior: "smooth",
      });
    },
  },
  methods: {
    getBackdrop: function (imageOnly = false) {
      backdrops = require.context("../assets/backdrops", true, /\.jpg$/);
      _.each(backdrops.keys(), function (image) {
        backdropImages.push(backdrops(image));
      });
      backdropImages = _.shuffle(backdropImages);

      if (imageOnly) {
        return _.first(backdropImages);
      } else {
        return {
          background: "url('" + _.first(backdropImages) + "') no-repeat center fixed",
          backgroundSize: "cover"
        };
      }
    },
    getBackdropImage: function () {
      return this.getBackdrop(true);
    },
    listenThruLivePlayer: function () {
      if (!player) {
        player = new Audio("http://stream.deltafm.nl:8123/;stream.mp3");
      }
      if (playerStatus === "playing") {
        player.pause();
        playerStatus = "paused";
      } else {
        player.play();
        playerStatus = "playing";
      }
    },
  },
};
</script>

<style scoped>
header.masthead {
  padding-top: 10.5rem;
  padding-bottom: 6rem;
  text-align: center;
  color: #fff;
  width: 100%;
  
}

.masthead-subheading {
  width: 85%;
  max-width: 450px;
  padding: 15px;
  margin: 0 auto;
  border-radius: 5px;
  z-index: 1;
  position: relative;
  background-color: rgba(33, 37, 41, 0.9);
  margin-left: 50%;
  transform: translateX(-50%);
}

.masthead-heading {
  color: #e35313;
}

.live .fa-circle {
  color: red;
}
</style>